import { useState, useEffect } from 'react';
import useApi, { GET_AVAILABLE_PEER_GROUPS } from 'hooks/useApi';

const useFetchTimeSeriesSets = () => {
  const [state, makeRequest] = useApi();
  const [options, setOptions] = useState([]);

  const { isLoading, isError, data, error } = state;

  useEffect(() => {
    makeRequest(GET_AVAILABLE_PEER_GROUPS());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isLoading || isError || error) {
      return;
    }
    if (data) {
      setOptions(data.map(d => ({ value: d.id, label: d.name })));
    }
  }, [isLoading, isError, error, data]);

  return [options, isError, error, isLoading];
};

export default useFetchTimeSeriesSets;
